import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
// Load print styles non-blocking: inject as <link media="print"> so browser skips it for screen rendering
import printCssUrl from "./styles/print.css?url";
const printLink = document.createElement("link");
printLink.rel = "stylesheet";
printLink.media = "print";
printLink.href = printCssUrl;
document.head.appendChild(printLink);

createRoot(document.getElementById("root")!).render(<App />);
